const fakeCoupon = [
  {
    _id: "690001a1a1a1a1a1a1a1a001",
    validServices: [
      { _id: "601abc001", name: "Manicura básica" },
      { _id: "601abc002", name: "Corte de cabello" },
    ],
    usersUsed: [],
    name: "Descuento Bienvenida",
    description: "20% de descuento en servicios seleccionados.",
    expirationDate: "2025-12-31T00:00:00.000Z",
    maxUses: 50,
    discountType: "Porcentaje",
    discount: 20,
    provider: "5e6b31a018048974ea17f435",
    createdAt: "2025-06-15T10:00:00.000Z",
    updatedAt: "2025-06-15T10:00:00.000Z",
    code: "WELCOME20",
    usesLeft: 50,
    __v: 0,
    id: "690001a1a1a1a1a1a1a1a001",
  },
  {
    _id: "690001a2a2a2a2a2a2a2a002",
    validServices: [{ _id: "601abc003", name: "Masaje relajante" }],
    usersUsed: ["user123", "user456"],
    name: "Cupón Relax",
    description: "50 Bs de descuento para masajes",
    expirationDate: "2025-08-01T00:00:00.000Z",
    maxUses: 20,
    discountType: "Monto",
    discount: 50,
    provider: "5e6b31a018048974ea17f435",
    createdAt: "2025-06-10T12:00:00.000Z",
    updatedAt: "2025-06-12T14:00:00.000Z",
    code: "RELAX50",
    usesLeft: 18,
    __v: 1,
    id: "690001a2a2a2a2a2a2a2a002",
  },
  {
    _id: "690001a3a3a3a3a3a3a3a003",
    validServices: [
      { _id: "601abc004", name: "Pedicura" },
      { _id: "601abc005", name: "Peinado especial" },
      { _id: "601abc006", name: "Tinte de cejas" },
    ],
    usersUsed: [],
    name: "Carnaval Beauty",
    description: "15% de descuento en servicios de belleza.",
    expirationDate: "2025-02-28T00:00:00.000Z",
    maxUses: 100,
    discountType: "Porcentaje",
    discount: 15,
    provider: "5e6b31a018048974ea17f435",
    createdAt: "2025-01-15T09:30:00.000Z",
    updatedAt: "2025-01-15T09:30:00.000Z",
    code: "CARNAVAL15",
    usesLeft: 100,
    __v: 0,
    id: "690001a3a3a3a3a3a3a3a003",
  },
];
export default fakeCoupon;
